(function() {
    'use strict';

    angular
        .module('atheer')
        .constant('toastConstants', {
            'position': 'top right'
        });
})();
